import { createStore } from 'zustand';
import { devtools } from 'zustand/middleware';

import { REPUBS_WITH_BOOKIE_LOGOS, REPUBS_WITH_TRANSLATED_BET_NAMES } from '@cx-modules/constants';

import type {
  DefaultProps,
  InitialState,
  OutrightsCouponState,
  SelectedBet,
  SyncBet,
} from './interfaces/outright-markets.interface';

export const createOutrightsCouponStore = ({
  oddsFormat = 'american',
  showBookieLogos,
  ...initialState
}: InitialState) => {
  const DEFAULT_PROPS: DefaultProps = {
    bettypeIds: null,
    countryCode: 'US',
    dataApiEndpoint: '/api',
    eventIds: [32448, 7165],
    repub: 'US',
    selectedBets: [] as SelectedBet[],
    subdivision: 'NJ',
    user: { oddsFormat },
  };
  const renderOddsButtonBadge = showBookieLogos ?? REPUBS_WITH_BOOKIE_LOGOS.includes(initialState.repub);
  const translateBetNames = REPUBS_WITH_TRANSLATED_BET_NAMES.includes(initialState.repub);

  return createStore<OutrightsCouponState>()(
    devtools(set => ({
      ...DEFAULT_PROPS,
      // TODO: we need to initialise the selectedBets
      // from the bet selections found in cookies
      ...initialState,
      addSelectedBet: (bet: SelectedBet) => {
        set((state: { selectedBets: SelectedBet[] }) => ({
          selectedBets: [...state.selectedBets.filter(b => b.betId !== bet.betId), bet],
        }));
      },
      removeAllSelectedBets: () => {
        set({ selectedBets: [] });
      },
      removeSelectedBet: (id: number) => {
        set((state: { selectedBets: SelectedBet[] }) => ({
          selectedBets: state.selectedBets.filter(b => b.betId !== id),
        }));
      },
      renderOddsButtonBadge,
      syncBetslip: (bets: SyncBet[], overwriteSelections?: boolean) => {
        set((state: { selectedBets?: SelectedBet[] }) => {
          // overwrite existing selections
          if (overwriteSelections) {
            return {
              selectedBets: bets.map(b => ({
                betId: b.betId,
                bookieCode: b.bestOddsBookmakers.split(',')[0],
              })),
            };
          }

          // retain existing selections
          const selectedBets = state.selectedBets || [];
          return {
            selectedBets: [
              ...selectedBets,
              ...bets.reduce((a: SelectedBet[], b: SyncBet) => {
                if (!selectedBets.find(({ betId }) => b.betId === betId)) {
                  a.push({
                    betId: b.betId,
                    bookieCode: b.bestOddsBookmakers.split(',')[0],
                  });
                }
                return a;
              }, []),
            ],
          };
        });
      },
      translateBetNames,
    })),
  );
};
